function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.setAttribute('role', 'button'),
    e.setAttribute('aria-expanded', e.parentNode.hasAttribute('open')),
    e.nextElementSibling.getAttribute('id') && e.setAttribute('aria-controls', e.nextElementSibling.id),
    e.addEventListener('click', (e) => {
      e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));
    }),
    e.closest('header-drawer, menu-drawer') || e.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var n = getFocusableElements(e),
    o = n[0],
    r = n[n.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== r && t.target !== o) ||
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      'TAB' === t.code.toUpperCase() &&
        (t.target !== r || t.shiftKey || (t.preventDefault(), o.focus()),
        (t.target !== e && t.target !== o) || !t.shiftKey || (t.preventDefault(), r.focus()));
    }),
    document.addEventListener('focusout', trapFocusHandlers.focusout),
    document.addEventListener('focusin', trapFocusHandlers.focusin),
    t.focus(),
    'INPUT' === t.tagName &&
      ['search', 'text', 'email', 'url'].includes(t.type) &&
      t.value &&
      t.setSelectionRange(0, t.value.length);
}
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const e = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let t = null,
    n = null;
  window.addEventListener('keydown', (t) => {
    e.includes(t.code.toUpperCase()) && (n = !1);
  }),
    window.addEventListener('mousedown', (e) => {
      n = !0;
    }),
    window.addEventListener(
      'focus',
      () => {
        t && t.classList.remove('focused'), n || ((t = document.activeElement), t.classList.add('focused'));
      },
      !0,
    );
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((e) => {
    e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }),
    document.querySelectorAll('.js-vimeo').forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', '*');
    }),
    document.querySelectorAll('video').forEach((e) => e.pause()),
    document.querySelectorAll('product-model').forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
function removeTrapFocus(e = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin),
    document.removeEventListener('focusout', trapFocusHandlers.focusout),
    document.removeEventListener('keydown', trapFocusHandlers.keydown),
    e && e.focus();
}
function onKeyUpEscape(e) {
  if ('ESCAPE' !== e.code.toUpperCase()) return;
  const t = e.target.closest('details[open]');
  if (!t) return;
  const n = t.querySelector('summary');
  t.removeAttribute('open'), n.setAttribute('aria-expanded', !1), n.focus();
}
function debounce(e, t) {
  let n;
  return (...o) => {
    clearTimeout(n), (n = setTimeout(() => e.apply(this, o), t));
  };
}
function fetchConfig(e = 'json') {
  return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/${e}` } };
}
void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var n = 0, o = e.options.length; n < o; n++) {
      var r = e.options[n];
      if (t == r.value || t == r.innerHTML) return (e.selectedIndex = n), n;
    }
  }),
  (Shopify.addListener = function (e, t, n) {
    e.addEventListener ? e.addEventListener(t, n, !1) : e.attachEvent('on' + t, n);
  }),
  (Shopify.postLink = function (e, t) {
    var n = (t = t || {}).method || 'post',
      o = t.parameters || {},
      r = document.createElement('form');
    for (var i in (r.setAttribute('method', n), r.setAttribute('action', e), o)) {
      var s = document.createElement('input');
      s.setAttribute('type', 'hidden'), s.setAttribute('name', i), s.setAttribute('value', o[i]), r.appendChild(s);
    }
    document.body.appendChild(r), r.submit(), document.body.removeChild(r);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, n) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(n.hideElement || t)),
      Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince();
  });
